module.exports = __webpack_public_path__ + "img/toilet_wheelchair.981d2475.png";